<!--  -->
<template>
  <div>
    <app-panel
      :title="panelTitle"
      :isExpand="showPlayPanel"
      :transparent="isTransparent"
      :modal="false"
      @cancel="closePlayForm"
      :width="350"
    >
      <!-- <div class="add-title map-blur-panel__title">播放音频</div> -->
      <div class="add-content" style="height: 100%; position: relative">
        <el-scrollbar style="height: 100%">
          <el-form ref="playForm" :model="playForm" style="height: 100%">
            <div class="flex-align form-column" style="padding-top: 25px">
              <el-form-item
                prop="playTime"
                label="播放时长"
                :rules="playRules.playTime"
                label-width="80px"
              >
                <template>
                  <el-input
                    type="number"
                    maxlength="10"
                    placeholder="请输入音频播放时长"
                    v-model="playForm.playTime"
                  >
                    <template slot="append">秒</template>
                  </el-input>
                </template>
              </el-form-item>
              <el-form-item
                prop="playOrder"
                label="播放顺序"
                :rules="playRules.playOrder"
                label-width="80px"
              >
                <template>
                  <el-select
                    v-model="playForm.playOrder"
                    clearable
                    placeholder="请选择音频播放顺序"
                  >
                    <el-option
                      v-for="item in playOrders"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </template>
              </el-form-item>
            </div>
            <el-form-item
              prop="audioList"
              label="已选音频文件"
              style="margin-top: 20px"
              :rules="playRules.audioList"
            >
              <span>({{ playForm.audioList.length || 0 }})</span>
              <template>
                <div class="text-right">
                  <el-button type="info" class="buttonDark" @click="addAudio">
                    添加
                  </el-button>
                </div>
                <div class="add-list map-blur-panel__content form-column">
                  <template
                    v-if="playForm.audioList && playForm.audioList.length"
                  >
                    <el-scrollbar style="height: 100%">
                      <div
                        class="device-item"
                        v-for="(item, index) in playForm.audioList"
                        :key="'play-audio-' + index"
                      >
                        <div class="flex-auto text-ellipse" :title="item.name">
                          <span>{{ item }}</span>
                        </div>
                        <div class="mr10">
                          <template v-if="playForm.playOrder === '0'">
                            <el-button
                              title="上移"
                              :disabled="index === 0"
                              type="text"
                              icon="icon iconfont-lunan icon-lunan-shangyi"
                              @click="moveUp('playForm', 'audioList', index)"
                            ></el-button>
                            <el-button
                              title="下移"
                              :disabled="
                                index === playForm.audioList.length - 1
                              "
                              type="text"
                              icon="icon iconfont-lunan icon-lunan-xiayi"
                              @click="moveDown('playForm', 'audioList', index)"
                            ></el-button>
                          </template>
                          <el-button
                            title="删除"
                            type="text"
                            class="font20"
                            icon="el-icon-remove-outline"
                            @click="removeItem('playForm', 'audioList', index)"
                          ></el-button>
                        </div>
                      </div>
                    </el-scrollbar>
                  </template>
                  <template v-else>
                    <div class="no-data-text">音频列表为空</div>
                  </template>
                </div>
              </template>
            </el-form-item>
            <el-form-item
              prop="deviceList"
              label="已选广播设备"
              :rules="playRules.deviceList"
            >
              <span>({{ playForm.deviceList.length || 0 }})</span>
              <template>
                <div class="text-right">
                  <!--                  <span>从地图选择广播设备</span>-->
                  <el-button
                    type="info"
                    class="buttonDark"
                    @click="handleChooseDevice(4)"
                  >
                    添加
                  </el-button>
                </div>
                <div class="add-list map-blur-panel__content form-column">
                  <template
                    v-if="playForm.deviceList && playForm.deviceList.length"
                  >
                    <el-scrollbar style="height: 100%">
                      <div
                        class="device-item"
                        v-for="(item, index) in playForm.deviceList"
                        :key="'play-device-' + index"
                      >
                        <div class="flex-auto text-ellipse" :title="item.name">
                          <i
                            class="item-icon iconfont-lunan icon-lunan-radio"
                          ></i>
                          <span>{{
                            item.name ||
                            item.thirdDeviceName ||
                            item.attr.thirdDeviceName
                          }}</span>
                        </div>
                        <el-button
                          title="删除"
                          type="text"
                          class="font20"
                          icon="el-icon-remove-outline"
                          @click="toggleDevice(item)"
                        ></el-button>
                      </div>
                    </el-scrollbar>
                  </template>
                  <template v-else>
                    <div class="no-data-text">设备列表为空</div>
                  </template>
                </div>
              </template>
            </el-form-item>
          </el-form>
        </el-scrollbar>
      </div>
      <div class="add-footer" slot="footer">
        <el-button @click="closePlayForm">取消</el-button>
        <el-button type="primary" @click="confirmPlayForm">确定</el-button>
      </div>
    </app-panel>
  </div>
</template>

<script>
import appPanel from "@src/components/business/app-panel/index.vue";
import { api } from "../api";
export default {
  props: {
    showPlayPanel: {
      type: Boolean,
      default: false,
    },
    modal: {
      type: Boolean,
      default: false,
    },
    checkedAudios: {
      type: Array,
      default: [],
    },
    checkPlayDevices: {
      type: Array,
      default: [],
    },
    panelTitle: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isTransparent: true,
      playForm: {
        deviceList: [],
        playTime: 60,
        playOrder: "0",
        audioList: [],
      },
      playOrders: [
        {
          value: "0",
          label: "顺序播放",
        },
        {
          value: "1",
          label: "随机播放",
        },
      ],
      playRules: {
        deviceList: [
          {
            required: true,
            message: "请选择广播设备",
            trigger: "change",
          },
        ],
        playTime: [
          {
            required: true,
            message: "请输入音频播放时长",
            trigger: "change",
          },
        ],
        playOrder: [
          {
            required: true,
            message: "请选择音频播放顺序",
            trigger: "change",
          },
        ],
        audioList: [
          {
            required: true,
            message: "请选择播放音频",
            trigger: ["change"],
          },
        ],
      },
    };
  },

  components: { appPanel },
  watch: {
    checkedAudios(newVal, oldVal) {
      console.log(newVal, "===audioList");
      newVal ? (this.playForm.audioList = newVal) : "";
      this.$refs.playForm.validateField("audioList");
    },
    checkPlayDevices(newVal, oldVal) {
      newVal ? (this.playForm.deviceList = newVal) : "";
      this.$refs.playForm.validateField("deviceList");
    },
    // filterText(val) {
    //   this.$refs.panelDeviceTree.filter(val);
    // },
    // filterAudio(val) {
    //   console.log(this.audioData, "this.audioData");
    // },
  },
  computed() {},

  mounted() {},

  methods: {
    addAudio() {
      this.$emit("addAudio");
    },
    handleChooseDevice(type) {
      this.$emit("handleChooseDevice", type);
    },
    moveDown(obj, prop, index) {
      let item = this[obj][prop].splice(index, 1)[0];
      this[obj][prop].splice(index + 1, 0, item);
    },
    moveUp(obj, prop, index) {
      let item = this[obj][prop].splice(index, 1)[0];
      this[obj][prop].splice(index - 1, 0, item);
    },
    removeItem(obj, prop, index) {
      this[obj][prop].splice(index, 1);
    },
    closePlayForm() {
      this.$refs.playForm.resetFields();
      //   this.showPlayPanel = false;
      this.$emit("closePlayForm");
      this.playForm.deviceList.forEach((item) => {
        console.log(item, "quxiao---item");
        this.choosedAudiosCopy = [];
        this.$emit("toggleDevice", item);
      });
      this.playForm = this.$options.data().playForm;
    },
    toggleDevice(item) {
      this.$emit("toggleDevice", item);
    },
    confirmPlayForm() {
      this.$refs.playForm.validate((res) => {
        if (res) {
          // this.closePlayForm();
          let audioList = this.playForm.audioList.map((item) => {
            return item;
          });
          let deviceList = this.playForm.deviceList.map((item) => {
            console.log(item, "88888888888888");
            let id = "";
            if (item.id) {
              id = item.attr.thirdDeviceId || item.id;
            }
            return item.thirdDeviceId || id;
          });
          let params = {
            // 播放时长 单位秒
            durations: this.playForm.playTime,
            // 文件名称列表
            fileList: audioList,
            // 1：随机播放 0：顺序播放
            randomPlay: this.playForm.playOrder,
            // 播放状态 startbct(开始广播) stopbct（停止广播）filecontrol （ 播放控制）  此接口固定传startbct(开始广播)
            rtType: "startbct",
            // 广播设备ID列表
            terminalIdList: deviceList,
          };
          this.$fetch(api.playAudio, params).then((res) => {
            if (res.success) {
              this.$message.success("音频创建成功");
              this.$emit("queryPlay");
              this.closePlayForm();
            } else {
              this.$message.error(res.msgContent || "音频创建失败");
            }
          });
        }
      });
      this.choosedAudiosCopy = [];
      //   this.$emit("confirmAudioDialog", this.choosedAudiosCopy);
    },
  },
};
</script>
<style lang='scss' scoped>
.add-list {
  border-radius: 5px;
  margin-top: 21px;
  // @include set_theme_color(background-color, menu-tab-bg-color);
  // height: 100px;
  background: rgba(13, 18, 28, 0.65);
  overflow: hidden;
}
.font20 {
  font-size: 20px;
}
.device-item {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  overflow: hidden;
  padding: 7px 10px;
  border-bottom: 1px solid #3b4253;
  &:last-child {
    border-bottom: none;
  }
  // @include set_theme_color(border-color, top-menu-border-color);
}
.form-column {
  background: rgba(13, 18, 28, 0.5);
  border-radius: 5px;
  // height: 50px;
  padding: 10px;
}
.text-right {
  text-align: right;
  position: absolute;
  top: 0;
  right: 0;
}
.no-data-text {
  height: 100px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
</style>